import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';
import ListSkillsScoringOptionsPage from '../SkillsScoringOptions/ListSkillsScoringOptionsPage';

// Lazy load pages
const ListSkillScoringParametersPage = loadable(() => import('./ListSkillScoringParametersPage'), {
  fallback: <Loader />,
});

const SkillScoringParametersRoute = ({ t }) => {
  return (
    <Routes>
      <Route path="list" element={<ListSkillScoringParametersPage t={t} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
      <Route path="/skills-scoring-options/:skillId" element={<ListSkillsScoringOptionsPage />} />
    </Routes>
  );
};

SkillScoringParametersRoute.propTypes = {
  t: PropTypes.func,
};

export default SkillScoringParametersRoute;